module.exports = __webpack_public_path__ + "static/ezriel-45ce65624599c253bb5eda9bdfd71d51.svg";